import {Marked} from 'marked';
import { getStyledATagFromText } from '../../../../../../utils/utils';
import DOMPurify from 'dompurify';

export const marked = new Marked(
  {mangle: false, headerIds: false, breaks: true, gfm: true, smartLists: true,},
  {
    renderer: {
      image(this: any, href: string | null, title: string | null, text: string) {
        const safeHref = encodeURIComponent(href || '');
        return `<div
          class="image-container"
          onclick="onMarkdownImageClicked('${safeHref}')"
          style="cursor:pointer;" >
            <img src="${href}" alt="${text}" onload="onMarkdownMediaLoad()" style="max-width: 100%; height: auto; max-height: 300px; object-fit: contain; margin: 8px 0;"/>
          </div>
        `;
      },
      paragraph(text: string) {
        if (text.startsWith('<video')) {
          const videoSrc = extractVideoSrc(text) || '';
          if (videoSrc) {
            return `<div class="message-video">
              <div class="message-video-box">
                <video class="message-img video-web" src="${videoSrc}" onloadeddata="onMarkdownMediaLoad()" preload="auto" controls/>
              </div>
            </div>`;
          }
        }
        // 在段落中用 p 包裹，避免 \n\n 无法换行
        return `<p>${text}</p>`;
      },
      link(this: any, href: string | null, title: string | null, text: string) {
        if (href) {
          return getStyledATagFromText(href, "message-marked_link", undefined, title || text || '');
        }
        return text;
      },
    },
  },
);

const extractVideoSrc = (text: string) => {
  const videoSrcRegex = /<video[^>]*src=["']([^"']*)["'][^>]*>/gi;
  const result = videoSrcRegex.exec(text);
  return result ? result[1] : null;
}

export const parseMarkdown = (text: string) => {
  // 不要手动替换，如把 \n\n 替换成 p 或者 <br/>，否则可能会导致Markdown结构被破坏，进而导致 bad case
  let ret = marked.parse(text);
  if (typeof ret === 'string') {
    const purified = DOMPurify.sanitize(ret,{
      USE_PROFILES: { html: true,},
      ADD_ATTR: ['onclick', 'target'],
      FORBID_TAGS: ['style']
    });
    return purified;
  } 
  return '';
};
